import { Skeleton } from '@/components/ui/skeleton'
import { ApplicationCard } from '../components/ApplicationCard'
import { useApplications } from '../hooks/useApplications'

export function ApplicationsPage() {
  const { applications, loading, error } = useApplications()

  return (
    <div className="container mx-auto px-6 py-16">
      <div className="mb-8 space-y-2">
        <h1 className="text-4xl font-bold">Applications</h1>
        <p className="text-muted-foreground">
          Explore open opportunities and apply to join ODD.
        </p>
      </div>

      {error && <p className="text-sm text-destructive">{error}</p>}

      {loading ? (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="space-y-3">
              <Skeleton className="aspect-video w-full rounded-lg" />
              <Skeleton className="h-5 w-3/4" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-2/3" />
            </div>
          ))}
        </div>
      ) : applications.length === 0 ? (
        <div className="py-20 text-center">
          <p className="text-lg font-medium">No open applications at this time.</p>
          <p className="mt-2 text-sm text-muted-foreground">Check back soon for new opportunities.</p>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {applications.map((app) => (
            <ApplicationCard key={app.id} application={app} />
          ))}
        </div>
      )}
    </div>
  )
}
